import(/* webpackMode: "eager" */ "/app/src/components/ui/index.ts");
